import { styled } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({

    closeIcon: {
        fontSize: '20px', 
        color: `${theme.palette.tertiary.closeIconColor} !important`,
    },
    imageStyle: {
        borderRadius: '6px',
        width: "236px"
    },
    qrCodeHeading : {
        fontFamily: 'Visuelt',
        fontSize: '16px',
        fontWeight: 500,
        margin : '15px 15px 10px',
        color: `${theme.palette.tertiary.updatePopUpTitle} !important`,
    }
}))

export const MessageLayout = styled('div')({
    padding: '8px',
    textAlign: 'center',
});
export const CloseIconFrame = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: 'solid 1px',
    borderColor: `${theme.palette.tertiary.popupHeadingBorder} !important`,
    borderStyle: 'none none groove none',
}));

export const InformationFrame = styled('div')({
    display: 'flex',
    justifyContent: 'center',
});
export const PopUpTitle = styled('div')(({ theme }) =>({
    padding: '16px',
    fontSize: '16px',
    fontFamily: 'Visuelt',
    fontWeight: '400',
    lineHeight: '18px',
    color: `${theme.palette.tertiary.cardText} !important`, 
}));
export const InfoMsg = styled('div')(({ theme }) =>({
    margin: '16px 0',
    padding: '0 16px',
    fontSize: '12px',
    fontFamily: 'Visuelt',
    fontWeight: '400',
    lineHeight: '18px',
    color: `${theme.palette.tertiary.headingText} !important`,
}));
export const ActionItem = styled('div')(({ theme }) => ({
    textAlign: 'center',
    '&>div:nth-child(1)': {
        flex: .5,
        color: '#FFFFFF',
        margin: '10px',
        background: `${theme.palette.tertiary.commonButtonBackground} !important`,
        borderRadius: '10px',
        fontWeight: '400',
        fontFamily: 'Visuelt',
        padding: '16px',
    },
    '&>div:nth-child(2)': {
        flex: .5,
        color: `${theme.palette.tertiary.commonButtonBackground} !important`,
        fontWeight: '500',
        fontFamily: 'Visuelt',
        padding: '16px',
    }
}));



